
import { Pipe, PipeTransform } from '@angular/core';
import { ShiftStatus, ShiftStatusTranslations } from 'src/app/core/interfaces/shift.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'shiftStatus',
    pure: false
})
export class ShiftStatusPipe implements PipeTransform {
    constructor(private localization: LocalizationService) { }

    transform(value: ShiftStatus | string): string {
        if (!value) {
            return '';
        }
        const lang = this.localization.getCachedLanguage();
        return lang === 'ar'
            ? ShiftStatusTranslations[value as ShiftStatus] || value
            : value;
    }
}
